const Null = () => null;

export default Null;
